import React from 'react'
import ReactDOM from 'react-dom'

import TypeAnimation from 'components/TypeAnimation'


class Frame extends React.Component {
  state = {
    timesClicked: 0,
    newElem: undefined,
  }

  onClick = () => {
    this.setState({ timesClicked: this.state.timesClicked + 1 })

    if (this.state.timesClicked === 25)
      this.start()
  }

  start = () => {
    console.log("start()")

    this.setState({
      newElem: <div
        style={{
          position: "fixed",
          top: "15px",
          left: "15px",
          width: "100vw",
          height: "100vh",
          zIndex: 100000,
        }}
      >
        <TypeAnimation texts={[`
          Йоу, Дневная Параша на связи
          Совместный блять трек нашего лейбла
          Как всегда ебали все ваши рты
          Ну щас вы собственно это и услышите, долбоебы
          Пошли нахуй
          Дневная Параша снова ебет рты ваши, но без Саши
          Был реп сегодня сильно ошарашен.
          Михаил Маваши стал не моден, скажем.
          Спросили пиздаболы не докажем
          DJ Zhora звучит гордо, ведь не зря
          В глазах нацфая после дудки пылает красная заря
          Оуе
          MC Клей как всегда как всегда на высоте
          Кто-то дует шмаль, кто-то порошок, а кто где
          Марек — нарик, смеялись пацаны в детстве
          Хули тут, вещими стали тексты
          Ведь все же помнят то место, где в две тысячи седьмом,
          Попивая ягуар за ссаным гаражом,
          Создавались первые хиты на коленке.
          А на стенке была надпись
          Маша Шлюха
          Ты сейчас, в то же время Степа
          Уехал на родной Кавказ
          Над Дневной Парашей сходится туман.
          Либо ты русский, либо уебан.
          Я поставил свежий новенький капкан:
          И ты в него попал, наш репчик зазвучал.
          В твоей штанине какаха
          Твоя телка Натаха —
          Смесь узбека и казаха.
          Я почесал в районе паха.
          Ну че, пахан,
          Кто в Тегеран, а кто тупо по горам.
          Если ты гурман, отведай мою подливу
          Она сладкая как малина.
          Как шоколадная подлива, ммм, *чмок-чмок*,
          Ты не видел, на что мы способны.
          Как Леня Дигорин, ты бесплоден.
          Покушай мои сухарики,
          Тебя поймали в падике,
          Твоя баба в парилке или в парике.
          У нас тут коммунизм рвётся в космос.
          Он так же ебется в поппес — он педик,
          Прячет он от нас вареник.
          Кеды почистил в понедельник.
          Ваш Бох — пидорас,
          Он дикобраз без игл.
          Я пернул на ИГИЛ.
          Лизнул кольцо Саурона,
          Почесал Озона,
          Поцеловал гандона.
          Я в рот ебал твою мать,
          Прийду насру ей на грудь.
          Я не хочу её ебать,
          Лучше мочи пойти хлебнуть,
          Говно вкусней её стряпни,
          А пук лучше звучит,
          Чем голос этой хуерги,
          Пойди и ёбни ей с ноги.
          Яичишки кролика в камышах,
          Пашах Пашок ему страшно,
          Сидит чего-то ждёт.
          Он не заметил ничего вокруг,
          Но вдруг... Минута молчания —
          Жора берёт в рот.
          Рифмы как у Бога,
          Перданул немного.
          На окном снег. Я оск ааааауа
          Я русский человек
          У мня много забот —
          Сижу дома, пью компот,
          Пока твоего деда
          Мой прадед ебёт в рот.
          Йоу йоу йоу, всё окей,
          На микро Клей, говорите не быстрей.
          Сюда, тут всем пизда.
          Слюда — дело дорогое.
          Из-за неё мы похороним.
          Помню, конечно, о всех наших.
          Это реп из Балашиха
          Здесь ганжа а а а-а-а а
          Блять, Жора блевать уже устал
          Уже устал, заебел, заебать
          Биты все на Казантип вдруг.
          Погнали смело, накурился сеном.
          И для вас расторгалу лупы
          Показал залупу.
          ....
          Ёоооооооб
          На вписке, как Гари Гудини
          Пару фокусов оформил.
          Передёрнул пипидон.
          Здесь притон, а где Антон?
          Где запасной варик?
          Водки стопарик.
          Хлопну варик, чтоб наверняка
          Из варик из мака какая макака-кака.
          И летел на самолёте, который разбился вроде.
          Пиздец поселился, с этого одним местом.
          Я в тесто кидаю шишки,
          Ненавижу вспышки,
          И больше люблю в пизду малышке
          В трусики, ты пугало, блять, что со звуком?
          Разобрался в лупсе, ну, допустим.
          Нас опустили на Руси
          Ты пососи, ДэПэ, сорян
        `]} />
      </div>
    })
  }

  render = () =>
    <div className="frame">
      <div className="frame__corner frame__corner--top frame__corner--top--left" />
      <div className="frame__corner frame__corner--top frame__corner--top--right" />
      <div className="frame__corner frame__corner--bottom frame__corner--bottom--left" />
      <div className="frame__corner frame__corner--bottom frame__corner--bottom--right" />
      <div className="frame__light" onClick={this.onClick} />
      {this.props.children}
      {this.state.newElem}
    </div>
}


export default Frame